/** Geteilte UI-Bausteine im etablierten Stil (Panel, Stat, PageHead, Leerzustände). */

import type { ComponentChildren } from "preact";
import { activeServer } from "./store";
import { t } from "./i18n";

export function PageHead({ title, sub, children }: { title: string; sub?: ComponentChildren; children?: ComponentChildren }) {
  return (
    <div class="page-head">
      <div>
        <h1>{title}</h1>
        {sub != null && <div class="sub">{sub}</div>}
      </div>
      {children != null && <div class="row">{children}</div>}
    </div>
  );
}

export function Panel({
  title,
  actions,
  children,
  bodyClass = "",
}: {
  title?: ComponentChildren;
  actions?: ComponentChildren;
  children: ComponentChildren;
  bodyClass?: string;
}) {
  return (
    <div class="panel">
      {(title != null || actions != null) && (
        <div class="panel-head">
          <h2>{title}</h2>
          {actions != null && <div class="row">{actions}</div>}
        </div>
      )}
      <div class={`panel-body ${bodyClass}`}>{children}</div>
    </div>
  );
}

export function Stat({ label, icon, value, sub }: { label: string; icon: string; value: ComponentChildren; sub?: string }) {
  return (
    <div class="stat">
      <span class="label"><span>{icon}</span>{label}</span>
      <div class="value">{value}</div>
      {sub && <div class="sub">{sub}</div>}
    </div>
  );
}

/** Hinweis, wenn kein Server gewählt ist. */
export function NoServer() {
  return (
    <Panel>
      <div class="empty">{t("view.noServerSelected")}</div>
    </Panel>
  );
}

/** True, wenn ein Server aktiv ist (sonst <NoServer/> rendern). */
export const hasServer = () => !!activeServer.value;
